import * as React from 'react';
import { SelectorListSize } from '../Content';

export type ToggleAllCheckboxProps = {
  /** string to be displayed in footer when `multiple` prop is used and no items are selected  */
  selectAllText?: string;
  /** string to be displayed in footer when `multiple` prop is used and some or all items ar selected */
  deselectAllText?: string;
  /** the amount of items which are not disabled */
  enabledItemsAmount: number;
  /** an array of not disabled items that are marked as selected */
  selectedEnabledItemsAmount: number;
  /** a function that selects all non-disabled items */
  selectAll: () => void;
  /** a function that deselects all non-disabled items */
  deselectAll: () => void;
  /** Controls the size of the checkbox label.  */
  size?: SelectorListSize;
  /** applied as data-hook HTML attribute that can be used to create driver in testing */
  dataHook?: string;
};

declare const ToggleAllCheckbox: React.FC<ToggleAllCheckboxProps>;
export { ToggleAllCheckbox };
